import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.addDocument`,
    defaultMessage: 'Add Document',
  },
  documentTemplate: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.documentTemplate`,
    defaultMessage: 'Document Template',
  },
  // AXHE-4106: both kinds are offered in one picker, grouped so it's clear
  // which is which — they're authored and configured in different places.
  documentsGroup: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.documentsGroup`,
    defaultMessage: 'Documents',
  },
  // Renamed in lockstep with the settings page's own copy of this heading
  // (OfferLetterTemplates/messages.ts `offerLetterTemplatesGroup`) — same words,
  // two ids, and renaming one alone would leave this picker teaching a
  // vocabulary the page it links to no longer uses (AXHE-4400).
  offerLetterTemplatesGroup: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.offerLetterTemplatesGroup`,
    defaultMessage: 'Signature templates',
  },
  editDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.editDocument`,
    defaultMessage: 'Edit Document',
  },
  roleSelectLabel: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.roleSelectLabel`,
    defaultMessage: '{role} Role',
  },
  updateDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.updateDocument`,
    defaultMessage: 'Update Document',
  },
  uniqueSigners: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.uniqueSigners`,
    defaultMessage: 'A user can only be assigned to one role.',
  },
  warningChangesToRoles: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.warningChangesToRoles`,
    defaultMessage:
      'Warning: Any changes to the roles will reflect to all instances of this document template within this document signing stage.',
  },
  // AXHE-4446: an offer letter template's roster names its signer ROLES, but who
  // fills each one is per-stage — exactly as it is for a legacy embedded
  // template. Deliberately does NOT block the save: a template is routinely
  // attached to a stage before the admin knows the countersigner
  // (OfferLetterTemplatesStage validates the mapping's shape only, and says so
  // — completeness is enforced at send time), so requiring it here would break
  // the attach-then-fill flow AXHE-3754 depends on.
  //
  // "A document can't be sent", not "An offer" — AXHE-4400 is renaming this
  // feature's recruiter-facing noun to the sent artifact (a DOCUMENT; what an
  // admin authors is a SIGNATURE TEMPLATE). Landing the new string here rather
  // than letting this one reach main and renaming it a second time.
  incompleteSigners: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.incompleteSigners`,
    defaultMessage:
      "A document can't be sent until every role has a signer. You can save this stage now and assign them later.",
    description:
      'Warning in the document modal when a signature template has a signer role with nobody assigned to it',
  },
  // The other half of the attachment/template split (AXHE-4446). This modal
  // configures the ATTACHMENT — who signs at this stage. The template's own
  // content and the roster of roles are shared by every stage using it, so they
  // are edited in the offer letter editor instead. The pencil on the row used to
  // land here, which conflated the two.
  editOfferLetterTemplate: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DocumentModal.editOfferLetterTemplate`,
    defaultMessage: 'Edit template content and signer roles',
    description:
      'Link from the document modal to the offer letter template editor, where the shared template itself is edited',
  },
});
